import { ProjectConsultModule } from './project/project-consult.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    ProjectConsultModule,
  ]
})
export class ProjectsRepositoryConsultModule {}
